import { Injectable } from "@angular/core";
import { AshaEmployeeRecord } from "../classes/domain/entities/website/masters/asha/asha-employee-record/ashaemployeerecord";
import { State } from "../classes/domain/entities/website/masters/state/state";
import { Zone } from "../classes/domain/entities/website/masters/zone/zone";
import { District } from "../classes/domain/entities/website/masters/district/district";
import { Block } from "../classes/domain/entities/website/masters/block/block";
import { PHC } from "../classes/domain/entities/website/masters/phc/phc";
import { SC } from "../classes/domain/entities/website/masters/sc/sc";
import { Village } from "../classes/domain/entities/website/masters/village/village";
import { UIUtils } from "./uiutils.service";
import { AFPostMaster } from "../classes/domain/entities/website/masters/sanctioned-posts/af-post/afpost";
import { BcmPostMaster } from "../classes/domain/entities/website/masters/sanctioned-posts/bcm-post/bcmpost";
import { DashboardDropdownHierarchy } from "../classes/domain/entities/website/dashboarddropdownhierarchy/dashboarddropdownhierarchy";
import { ContraceptivePillsTypes, DashboardDropdownHierarchyLevels } from "../classes/infrastructure/enums";
import { DashboardFilterState } from "./dashboard-filter-state-storage.service";

@Injectable({
  providedIn: "root",
})
export class DashboardHierarchyFilterService {

  // ✅ Disabled states
  IsStateDisabled: boolean = false;
  IsZoneDisabled: boolean = false;
  IsDistrictDisabled: boolean = false;
  IsBlockDisabled: boolean = false;
  IsBCMPostDisabled: boolean = false;
  IsPHCDisabled: boolean = false;
  IsAFPostDisabled: boolean = false;
  IsSCDisabled: boolean = false;
  IsVillageDisabled: boolean = false;
  IsAshaDisabled: boolean = false;

  FilterDataList: DashboardDropdownHierarchy[] = [];
  StateList: State[] = [];
  ZoneList: Zone[] = [];
  DistrictList: District[] = [];
  BlockList: Block[] = [];
  BCMPostList: BcmPostMaster[] = [];
  PHCList: PHC[] = [];
  AFList: AFPostMaster[] = [];
  SCList: SC[] = [];
  VillageList: Village[] = [];
  AshaList: AshaEmployeeRecord[] = [];

  state_ids: number[] = [];
  zone_ids: number[] = [];
  district_ids: number[] = [];
  block_ids: number[] = [];
  bcm_post_ids: number[] = [];
  phc_ids: number[] = [];
  sc_ids: number[] = [];
  village_ids: number[] = [];
  asha_ids: number[] = [];
  af_ids: number[] = [];

  ReportFilterType: number = 0;
  QuarterlyYearType: number = 0;
  HalfYearType: number = 0;
  Month: number = 0;
  FinancialYearRef: number = 0;
  IncentiveRole: number = 0;
  AnemiaMuktaBharatType: number = 0;
  AnemiaMuktaBharatTabletclickedItem: string = '';
  FromDate: string = '';
  ToDate: string = '';

  CardType: string = "";
  StateIncentiveType: number = 0;
  IncentiveType: number = 0;
  // In DashboardFilterService
  ContraceptivePillType: ContraceptivePillsTypes = ContraceptivePillsTypes.None;
  
  // If your service currently looks like this:
  DropdownLimits = DashboardDropdownHierarchyLevels;

  constructor(private uiUtils: UIUtils) { }

  // ✅ Generic private fetcher — uses current service refs
  private async fetchHierarchyList(level: number): Promise<DashboardDropdownHierarchy[]> {
    // debugger
    return await DashboardDropdownHierarchy.FetchEntireListByFilter(
      this.FinancialYearRef, this.IncentiveRole,
      this.ReportFilterType, this.HalfYearType, this.QuarterlyYearType,
      this.Month, this.ToDate, this.FromDate,
      level,
      this.state_ids, this.zone_ids, this.district_ids,
      this.block_ids, this.bcm_post_ids, this.phc_ids,
      this.af_ids, this.sc_ids, this.village_ids, this.asha_ids,
      async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
    );
  }

  // ✅ Override fetcher — allows clearing specific refs for restore
  private async fetchHierarchyListWithOverride(
    level: number,
    override: {
      state_ids?: number[];
      zone_ids?: number[];
      district_ids?: number[];
      block_ids?: number[];
      bcm_post_ids?: number[];
      phc_ids?: number[];
      af_ids?: number[];
      sc_ids?: number[];
      village_ids?: number[];
      asha_ids?: number[];
    } = {}
  ): Promise<DashboardDropdownHierarchy[]> {
    return await DashboardDropdownHierarchy.FetchEntireListByFilter(
      this.FinancialYearRef, this.IncentiveRole,
      this.ReportFilterType, this.HalfYearType, this.QuarterlyYearType,
      this.Month, this.ToDate, this.FromDate,
      level,
      override.state_ids ?? this.state_ids,
      override.zone_ids ?? this.zone_ids,
      override.district_ids ?? this.district_ids,
      override.block_ids ?? this.block_ids,
      override.bcm_post_ids ?? this.bcm_post_ids,
      override.phc_ids ?? this.phc_ids,
      override.af_ids ?? this.af_ids,
      override.sc_ids ?? this.sc_ids,
      override.village_ids ?? this.village_ids,
      override.asha_ids ?? this.asha_ids,
      async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
    );
  }

  async LoadFilterDataUPTOStateLevel() {
    this.IsStateDisabled = false;
    // debugger
    const lst = await this.fetchHierarchyList(this.DropdownLimits.State);
    this.FilterDataList = lst;

    const stateMap = new Map();
    this.FilterDataList.forEach((e: DashboardDropdownHierarchy) => {
      const ref = e.p.StateRef;
      const name = e.p.StateNameEn;
      if (ref && !stateMap.has(ref)) {
        let state = State.CreateNewInstance();
        state.p.id = ref;
        state.p.name_en = name || "";
        stateMap.set(ref, state);
      }
    });

    this.StateList = Array.from(stateMap.values())
      .sort((a, b) => (a.p.name_en || "").localeCompare(b.p.name_en || ""));

    console.log('StateList:', this.StateList);

    // ⭐ AUTO SELECT IF ONLY ONE STATE
    if (this.state_ids.length === 0 && this.StateList.length === 1) {
      this.state_ids = [this.StateList[0].p.id];
      this.IsStateDisabled = true;
      await this.LoadFilterDataUPTOZoneLevel();
    }

    return this.StateList;
  }

  async LoadFilterDataUPTOZoneLevel() {
    if (this.state_ids.length === 0) return;

    const lst = await this.fetchHierarchyList(this.DropdownLimits.Zone);
    this.FilterDataList = lst;

    const zoneMap = new Map();
    this.FilterDataList.forEach((e) => {
      const ref = e.p.ZoneRef;
      const name = e.p.ZoneName;
      if (ref && !zoneMap.has(ref)) {
        let zone = Zone.CreateNewInstance();
        zone.p.id = ref;
        zone.p.name = name || "";
        zoneMap.set(ref, zone);
      }
    });

    if (zoneMap.size > 0) {
      this.ZoneList = Array.from(zoneMap.values())
        .sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));
    }

    console.log('ZoneList:', this.ZoneList);

    // ⭐ AUTO SELECT IF ONLY ONE ZONE
    if (this.zone_ids.length === 0 && this.ZoneList.length === 1) {
      this.zone_ids = [this.ZoneList[0].p.id];
      this.IsZoneDisabled = true;
      await this.LoadFilterDataUPTODistrictLevel();
    }

    return this.ZoneList;
  }

  async LoadFilterDataUPTODistrictLevel() {
    // ⭐ CLEAR OLD SELECTIONS
    this.district_ids = [];
    this.IsDistrictDisabled = false;

    const lst = await this.fetchHierarchyList(this.DropdownLimits.District);
    this.FilterDataList = lst;

    const districtMap = new Map();
    this.FilterDataList.forEach((e: DashboardDropdownHierarchy) => {
      const ref = e.p.DistrictRef;
      const name = e.p.DistrictNameEn;
      if (ref && !districtMap.has(ref)) {
        let district = District.CreateNewInstance();
        district.p.id = ref;
        district.p.name_en = name || "";
        districtMap.set(ref, district);
      }
    });

    this.DistrictList = Array.from(districtMap.values())
      .sort((a, b) => (a.p.name_en || "").localeCompare(b.p.name_en || ""));

    console.log('DistrictList:', this.DistrictList);

    // ⭐ AUTO SELECT IF ONLY ONE DISTRICT
    if (this.DistrictList.length === 1) {
      this.district_ids = [this.DistrictList[0].p.id];
      this.IsDistrictDisabled = true;
      await this.LoadFilterDataUPTOBlockLevel();
    }

    return this.DistrictList;
  }

  async LoadFilterDataUPTOBlockLevel() {
    // ⭐ CLEAR OLD SELECTIONS
    this.block_ids = [];
    this.bcm_post_ids = [];
    this.phc_ids = [];
    this.af_ids = [];
    this.sc_ids = [];
    this.village_ids = [];
    this.asha_ids = [];
    this.IsBlockDisabled = false;

    const lst = await this.fetchHierarchyList(this.DropdownLimits.Block);
    this.FilterDataList = lst;

    const blockMap = new Map();
    this.FilterDataList.forEach((e: DashboardDropdownHierarchy) => {
      const ref = e.p.BlockRef;
      const name = e.p.BlockNameEn;
      if (ref && !blockMap.has(ref)) {
        let block = Block.CreateNewInstance();
        block.p.id = ref;
        block.p.name_en = name || "";
        blockMap.set(ref, block);
      }
    });

    this.BlockList = Array.from(blockMap.values())
      .sort((a, b) => (a.p.name_en || "").localeCompare(b.p.name_en || ""));

    console.log('BlockList:', this.BlockList);

    // ⭐ AUTO SELECT IF ONLY ONE BLOCK
    if (this.BlockList.length === 1) {
      this.block_ids = [this.BlockList[0].p.id];
      this.IsBlockDisabled = true;
      await this.LoadFilterDataUPTOBCMPostLevel();
    }

    return this.BlockList;
  }

  async LoadFilterDataUPTOBCMPostLevel() {
    // ⭐ CLEAR OLD SELECTIONS
    this.bcm_post_ids = [];
    this.phc_ids = [];
    this.af_ids = [];
    this.sc_ids = [];
    this.village_ids = [];
    this.asha_ids = [];
    this.IsBCMPostDisabled = false;  // ✅ fixed flag

    const lst = await this.fetchHierarchyList(this.DropdownLimits.BCM);
    this.FilterDataList = lst;

    const bcmPostMap = new Map();
    this.FilterDataList.forEach((e: DashboardDropdownHierarchy) => {
      const ref = e.p.BCMPostRef;
      const name = e.p.BCMPostName;
      if (ref && !bcmPostMap.has(ref)) {
        let bcmPost = BcmPostMaster.CreateNewInstance();
        bcmPost.p.id = ref;
        bcmPost.p.name = name || "";
        bcmPostMap.set(ref, bcmPost);
      }
    });

    this.BCMPostList = Array.from(bcmPostMap.values())
      .sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));

    console.log('BCMPostList:', this.BCMPostList);

    // ⭐ AUTO SELECT IF ONLY ONE BCM POST
    if (this.BCMPostList.length === 1) {
      this.bcm_post_ids = [this.BCMPostList[0].p.id];
      this.IsBCMPostDisabled = true;
      await this.LoadFilterDataUPTOPHCLevel();
    }

    return this.BCMPostList;
  }

  async LoadFilterDataUPTOPHCLevel() {
    // ⭐ CLEAR OLD SELECTIONS
    this.phc_ids = [];
    this.af_ids = [];
    this.sc_ids = [];
    this.village_ids = [];
    this.asha_ids = [];
    this.IsPHCDisabled = false;

    const lst = await this.fetchHierarchyList(this.DropdownLimits.PHC);
    this.FilterDataList = lst;

    const phcMap = new Map();
    this.FilterDataList.forEach((e: DashboardDropdownHierarchy) => {
      const ref = e.p.PHCRef;
      const name = e.p.PHCName;
      if (ref && !phcMap.has(ref)) {
        let phc = PHC.CreateNewInstance();
        phc.p.id = ref;
        phc.p.name = name || "";
        phcMap.set(ref, phc);
      }
    });

    this.PHCList = Array.from(phcMap.values())
      .sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));

    console.log('PHCList:', this.PHCList);

    // ⭐ AUTO SELECT IF ONLY ONE PHC
    if (this.PHCList.length === 1) {
      this.phc_ids = [this.PHCList[0].p.id];
      this.IsPHCDisabled = true;
      await this.LoadFilterDataUPTOAFPostLevel();
    }

    return this.PHCList;
  }

  async LoadFilterDataUPTOAFPostLevel() {
    // ⭐ CLEAR OLD SELECTIONS
    this.af_ids = [];
    this.sc_ids = [];
    this.village_ids = [];
    this.asha_ids = [];
    this.IsAFPostDisabled = false;

    const lst = await this.fetchHierarchyList(this.DropdownLimits.AF);
    this.FilterDataList = lst;

    const afMap = new Map();
    this.FilterDataList.forEach((e: DashboardDropdownHierarchy) => {
      const ref = e.p.AFPostRef;
      const name = e.p.AFPostName;
      if (ref && !afMap.has(ref)) {
        let af = AFPostMaster.CreateNewInstance();
        af.p.id = ref;
        af.p.name = name || "";
        afMap.set(ref, af);
      }
    });

    this.AFList = Array.from(afMap.values())
      .sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));

    console.log('AFList:', this.AFList);

    // ⭐ AUTO SELECT IF ONLY ONE AF
    if (this.AFList.length === 1) {
      this.af_ids = [this.AFList[0].p.id];
      this.IsAFPostDisabled = true;
      await this.LoadFilterDataUPTOSCLevel();
    }

    return this.AFList;
  }

  async LoadFilterDataUPTOSCLevel() {
    // ⭐ CLEAR OLD SELECTIONS
    this.sc_ids = [];
    this.village_ids = [];
    this.asha_ids = [];
    this.IsSCDisabled = false;

    const lst = await this.fetchHierarchyList(this.DropdownLimits.SC);
    this.FilterDataList = lst;

    const scMap = new Map();
    this.FilterDataList.forEach((e: DashboardDropdownHierarchy) => {
      const ref = e.p.SCRef;
      const name = e.p.SCName;
      if (ref && !scMap.has(ref)) {
        let sc = SC.CreateNewInstance();
        sc.p.id = ref;
        sc.p.name = name || "";
        scMap.set(ref, sc);
      }
    });

    this.SCList = Array.from(scMap.values())
      .sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));

    console.log('SCList:', this.SCList);

    // ⭐ AUTO SELECT IF ONLY ONE SC
    if (this.SCList.length === 1) {
      this.sc_ids = [this.SCList[0].p.id];
      this.IsSCDisabled = true;
      await this.LoadFilterDataUPTOVillageLevel();
    }

    return this.SCList;
  }

  async LoadFilterDataUPTOVillageLevel() {
    // ⭐ CLEAR OLD SELECTIONS
    this.village_ids = [];
    this.asha_ids = [];
    this.IsVillageDisabled = false;

    const lst = await this.fetchHierarchyList(this.DropdownLimits.Village);
    this.FilterDataList = lst;

    const villageMap = new Map();
    this.FilterDataList.forEach((e: DashboardDropdownHierarchy) => {
      const ref = e.p.VillageRef;
      const name = e.p.VillageNameEn;
      if (ref && !villageMap.has(ref)) {
        let village = Village.CreateNewInstance();
        village.p.id = ref;
        village.p.name_en = name || "";
        villageMap.set(ref, village);
      }
    });

    this.VillageList = Array.from(villageMap.values())
      .sort((a, b) => (a.p.name_en || "").localeCompare(b.p.name_en || ""));

    console.log('VillageList:', this.VillageList);

    // ⭐ AUTO SELECT IF ONLY ONE VILLAGE
    if (this.VillageList.length === 1) {
      this.village_ids = [this.VillageList[0].p.id];
      this.IsVillageDisabled = true;
      await this.LoadFilterDataUPTOAshaLevel();
    }

    return this.VillageList;
  }

  async LoadFilterDataUPTOAshaLevel() {
    // ⭐ CLEAR OLD SELECTIONS
    this.asha_ids = [];
    this.IsAshaDisabled = false;

    const lst = await this.fetchHierarchyList(this.DropdownLimits.Asha);
    this.FilterDataList = lst;

    const ashaMap = new Map();
    this.FilterDataList.forEach((e: DashboardDropdownHierarchy) => {
      const ref = e.p.AshaEmployeeRecordRef;
      const name = e.p.AshaFullName;
      if (ref && !ashaMap.has(ref)) {
        let asha = AshaEmployeeRecord.CreateNewInstance();
        asha.p.id = ref;
        asha.p.asha_full_name = name || "";
        ashaMap.set(ref, asha);
      }
    });

    this.AshaList = Array.from(ashaMap.values())
      .sort((a, b) => (a.p.asha_full_name || "").localeCompare(b.p.asha_full_name || ""));

    console.log('AshaList:', this.AshaList);

    // ⭐ AUTO SELECT IF ONLY ONE ASHA
    if (this.AshaList.length === 1) {
      this.asha_ids = [this.AshaList[0].p.id];
      this.IsAshaDisabled = true;
    }

    return this.AshaList;
  }

  // ✅ Restore all filter state and reload dropdown lists
  async restoreFromStoredState(storedState: DashboardFilterState) {
    // ⭐ Step 1: Restore all refs and params first
    if (storedState.FinancialYearRef && storedState.FinancialYearRef !== 0) {
      this.FinancialYearRef = storedState.FinancialYearRef;
    }
    if (storedState.IncentiveRole && storedState.IncentiveRole !== 0) {
      this.IncentiveRole = storedState.IncentiveRole;
    }
    this.ReportFilterType = storedState.ReportFilterType;
    this.Month = storedState.Month;
    this.QuarterlyYearType = storedState.QuarterlyYearType;
    this.HalfYearType = storedState.HalfYearType;
    this.state_ids = storedState.state_ids ?? [];
    this.zone_ids = storedState.zone_ids ?? [];
    this.district_ids = storedState.district_ids ?? [];
    this.block_ids = storedState.block_ids ?? [];
    this.bcm_post_ids = storedState.bcm_post_ids ?? [];
    this.phc_ids = storedState.phc_ids ?? [];
    this.af_ids = storedState.af_ids ?? [];
    this.sc_ids = storedState.sc_ids ?? [];
    this.village_ids = storedState.village_ids ?? [];
    this.asha_ids = storedState.asha_ids ?? [];

    // ⭐ Step 2: Load State list — clear state_ids override so ALL states come back
    const stateLst = await this.fetchHierarchyListWithOverride(
      this.DropdownLimits.State, { state_ids: [] }
    );
    const stateMap = new Map();
    stateLst.forEach(e => {
      if (e.p.StateRef && !stateMap.has(e.p.StateRef)) {
        let s = State.CreateNewInstance();
        s.p.id = e.p.StateRef;
        s.p.name_en = e.p.StateNameEn || '';
        stateMap.set(e.p.StateRef, s);
      }
    });
    this.StateList = Array.from(stateMap.values())
      .sort((a, b) => (a.p.name_en || "").localeCompare(b.p.name_en || ""));

    if (this.state_ids.length === 0) return;

    // ⭐ Load Zone list
    const zoneLst = await this.fetchHierarchyListWithOverride(
      this.DropdownLimits.Zone, { zone_ids: [] }
    );
    const zoneMap = new Map();
    zoneLst.forEach(e => {
      if (e.p.ZoneRef && !zoneMap.has(e.p.ZoneRef)) {
        let z = Zone.CreateNewInstance();
        z.p.id = e.p.ZoneRef;
        z.p.name = e.p.ZoneName || '';
        zoneMap.set(e.p.ZoneRef, z);
      }
    });
    this.ZoneList = Array.from(zoneMap.values())
      .sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));

    if (this.zone_ids.length === 0) return;

    // ⭐ Load District list
    const distLst = await this.fetchHierarchyListWithOverride(
      this.DropdownLimits.District, { district_ids: [] }
    );
    const distMap = new Map();
    distLst.forEach(e => {
      if (e.p.DistrictRef && !distMap.has(e.p.DistrictRef)) {
        let d = District.CreateNewInstance();
        d.p.id = e.p.DistrictRef;
        d.p.name_en = e.p.DistrictNameEn || '';
        distMap.set(e.p.DistrictRef, d);
      }
    });
    this.DistrictList = Array.from(distMap.values())
      .sort((a, b) => (a.p.name_en || "").localeCompare(b.p.name_en || ""));

    if (this.district_ids.length === 0) return;

    // ⭐ Load Block list
    const blockLst = await this.fetchHierarchyListWithOverride(
      this.DropdownLimits.Block, { block_ids: [] }
    );
    const blockMap = new Map();
    blockLst.forEach(e => {
      if (e.p.BlockRef && !blockMap.has(e.p.BlockRef)) {
        let b = Block.CreateNewInstance();
        b.p.id = e.p.BlockRef;
        b.p.name_en = e.p.BlockNameEn || '';
        blockMap.set(e.p.BlockRef, b);
      }
    });
    this.BlockList = Array.from(blockMap.values())
      .sort((a, b) => (a.p.name_en || "").localeCompare(b.p.name_en || ""));

    if (this.block_ids.length === 0) return;

    // ⭐ Load BCMPost list
    const bcmLst = await this.fetchHierarchyListWithOverride(
      this.DropdownLimits.BCM, { bcm_post_ids: [] }
    );
    const bcmMap = new Map();
    bcmLst.forEach(e => {
      if (e.p.BCMPostRef && !bcmMap.has(e.p.BCMPostRef)) {
        let b = BcmPostMaster.CreateNewInstance();
        b.p.id = e.p.BCMPostRef;
        b.p.name = e.p.BCMPostName || '';
        bcmMap.set(e.p.BCMPostRef, b);
      }
    });
    this.BCMPostList = Array.from(bcmMap.values())
      .sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));

    if (this.bcm_post_ids.length === 0) return;

    // ⭐ Load PHC list
    const phcLst = await this.fetchHierarchyListWithOverride(
      this.DropdownLimits.PHC, { phc_ids: [] }
    );
    const phcMap = new Map();
    phcLst.forEach(e => {
      if (e.p.PHCRef && !phcMap.has(e.p.PHCRef)) {
        let p = PHC.CreateNewInstance();
        p.p.id = e.p.PHCRef;
        p.p.name = e.p.PHCName || '';
        phcMap.set(e.p.PHCRef, p);
      }
    });
    this.PHCList = Array.from(phcMap.values())
      .sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));

    if (this.phc_ids.length === 0) return;

    // ⭐ Load AF list
    const afLst = await this.fetchHierarchyListWithOverride(
      this.DropdownLimits.AF, { af_ids: [] }
    );
    const afMap = new Map();
    afLst.forEach(e => {
      if (e.p.AFPostRef && !afMap.has(e.p.AFPostRef)) {
        let a = AFPostMaster.CreateNewInstance();
        a.p.id = e.p.AFPostRef;
        a.p.name = e.p.AFPostName || '';
        afMap.set(e.p.AFPostRef, a);
      }
    });
    this.AFList = Array.from(afMap.values())
      .sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));

    if (this.af_ids.length === 0) return;

    // ⭐ Load SC list
    const scLst = await this.fetchHierarchyListWithOverride(
      this.DropdownLimits.SC, { sc_ids: [] }
    );
    const scMap = new Map();
    scLst.forEach(e => {
      if (e.p.SCRef && !scMap.has(e.p.SCRef)) {
        let s = SC.CreateNewInstance();
        s.p.id = e.p.SCRef;
        s.p.name = e.p.SCName || '';
        scMap.set(e.p.SCRef, s);
      }
    });
    this.SCList = Array.from(scMap.values())
      .sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));

    if (this.sc_ids.length === 0) return;

    // ⭐ Load Village list
    const villageLst = await this.fetchHierarchyListWithOverride(
      this.DropdownLimits.Village, { village_ids: [] }
    );
    const villageMap = new Map();
    villageLst.forEach(e => {
      if (e.p.VillageRef && !villageMap.has(e.p.VillageRef)) {
        let v = Village.CreateNewInstance();
        v.p.id = e.p.VillageRef;
        v.p.name_en = e.p.VillageNameEn || '';
        villageMap.set(e.p.VillageRef, v);
      }
    });
    this.VillageList = Array.from(villageMap.values())
      .sort((a, b) => (a.p.name_en || "").localeCompare(b.p.name_en || ""));

    if (this.village_ids.length === 0) return;

    // ⭐ Load Asha list
    const ashaLst = await this.fetchHierarchyListWithOverride(
      this.DropdownLimits.Asha, { asha_ids: [] }
    );
    const ashaMap = new Map();
    ashaLst.forEach(e => {
      if (e.p.AshaEmployeeRecordRef && !ashaMap.has(e.p.AshaEmployeeRecordRef)) {
        let a = AshaEmployeeRecord.CreateNewInstance();
        a.p.id = e.p.AshaEmployeeRecordRef;
        a.p.asha_full_name = e.p.AshaFullName || '';
        ashaMap.set(e.p.AshaEmployeeRecordRef, a);
      }
    });
    this.AshaList = Array.from(ashaMap.values())
      .sort((a, b) => (a.p.asha_full_name || "").localeCompare(b.p.asha_full_name || ""));
  }
}                                                                 